import { useCallback } from 'react';

import { DropdownButton } from '../DropdownButton';
import type { IPageLimitList } from './Pagination.helpers';
import { pageLimitOptions } from './Pagination.helpers';

export const PageLimitList = ({ pageLimit, onLimitChange, isLoading }: IPageLimitList) => {
	const handlePagelimitClick = useCallback(
		(limit: number, toggleVisibilityFn?: () => void) => () => {
			if (isLoading) return;
			onLimitChange(limit);
			toggleVisibilityFn?.();
		},
		[isLoading, onLimitChange]
	);

	const dropDownComponent = useCallback(
		(toggleVisibility?: () => void) => (
			<ul className='bt_pagination_pagelimit_list'>
				{pageLimitOptions.map((option) => (
					<li key={option}>
						<button
							type='button'
							className={`bt_pagination_pagelimit_list_item${option === pageLimit ? ' selectedItem' : ''}`}
							onClick={handlePagelimitClick(option, toggleVisibility)}
						>
							{option}
						</button>
					</li>
				))}
			</ul>
		),
		[handlePagelimitClick, pageLimit]
	);

	return (
		<DropdownButton
			label={`${pageLimit} / page`}
			placement='right'
			variant='outline'
			dropDownComponent={dropDownComponent}
		/>
	);
};
